// Styles
import styles from './index.module.css'

// Utilities
import pages from 'constants/pages'

// Components
import Button from 'components/Button'
import { NavLink } from 'react-router-dom'
import Header from './components/header'
import Section from './components/section'

export default function Terms() {
  return (
    <div
      className={`${styles.counter} w-full sm:px-14 lg:px-24 xs:px-8 px-4 pt-24 bg-primary-background [&>*]:max-w-5xl pb-10`}
    >
      <Header pageName="Termeni și condiții" lastUpdate="17.09.2024" />
      <Section>
        <h2>Identitatea firmei și descrierea serviciilor</h2>
        <p>
          SC ITOIT MEDITAȚII SRL cu sediul în municipiul Alexandria, județul
          Teleorman, Strada 1907, numărul 47 , în continuare denumit ItoIT, își
          desfășoară activitatea în domeniul pregătirii la informatică prin
          intermediul site-ului {process.env.REACT_APP_URL}
        </p>
      </Section>
      <Section>
        <h2>Drepturile și obligațiile firmei</h2>
        <p>
          ItoIT își rezervă dreptul de a trimite știri și oferte utilizatorilor
          sub forma unor emailuri. Utilizatorul poate întrerupe primirea acestor
          emailuri printr-o cerere scrisă în secțiunea de contact.
        </p>
        <p>
          ItoIT își rezervă dreptul de modificare al conținutului site-ului sau
          al termenilor și condițiilor fără a informa utilizatorul în prealabil.
        </p>
        <p>
          ItoIT își rezervă dreptul de a selecta comentariile care vor fi
          evidențiate pe site.
        </p>
        <p>
          ItoIT are ca scop prezentarea unor informații cât mai exacte pentru
          toți utilizatorii. Totuși nu putem garanta pentru corectitudinea
          tuturor informațiilor prezente pe site. ItoIT nu se face responsabilă
          pentru eventualele daune produse utilizatorului. ItoIT nu se face
          responsabilă pentru corectitudinea informațiilor site-urilor la care
          se ajunge prin legături externe de pe {process.env.REACT_APP_URL}.
          Proprietarii respectivelor site-uri poartă răspunderea integrală în
          acest caz.
        </p>
        <p>
          ItoIT nu se face responsabilă pentru afisarea eronată a conținutului
          site-ului datorată folosirii unui anumit browser.
        </p>
      </Section>
      <Section>
        <h2>Drepturile și obligațiile utilizatorului</h2>
        <p>Utilizatorul are obligația de a nu furniza informații false.</p>

        <p>
          Utilizatorul are obligația de a nu furniza datele de logare altor
          persoane. Prin folosirea {process.env.REACT_APP_URL} utilizatorul se
          face răspunzător pentru pastrarea confidențialității datelor de
          logare. ItoIT nu își asumă responsibilitatea pentru conturile pierdute
          sau furate în astfel de cazuri.
        </p>

        <p>
          Utilizatorul are obligația de a nu încerca să acceseze datele altor
          utilizatori, de a modifica conținutul site-ului sau de a deteriora
          performanțele acestuia în orice fel. Orice tentativă de acest gen este
          considerată fraudă.
        </p>

        <p>
          Utilizatorul beneficiază de urmatoarele drepturi: dreptul de acces la
          date, dreptul de intervenție asupra datelor, dreptul de opoziție,
          dreptul de a se adresa justiției, așa cum este reglementat in legea
          677/2001.
        </p>
      </Section>
      <Section>
        <h2>Prețuri</h2>
        <p>
          Prețurile prezentate pe site includ toate taxele aferente, mai puțin
          în cazul în care se specifică explicit altfel.
        </p>

        <p>
          În cazul în care prețul real este mai mic decât cel publicat eronat pe
          site, ItoIT va trimite o înstiintare utilizatorului, pe adresa de
          email furnizată în formularul de înregistrare. Utilizatorul are
          posibilitatea de a recupera diferența de bani dupa cum se va conveni
          între ambele parți, în termen maxim de 14 zile de la efectuarea
          platii.
        </p>
      </Section>
      <Section>
        <h2>Politica de retur</h2>
        <p>
          Conform ordonanței de urgență nr 34/2014 consumatorul beneficiază de o
          perioadă de 14 zile pentru a se retrage dintr-un contract la distanţă
          sau dintr-un contract în afara spaţiilor comerciale, fără a fi nevoit
          să justifice decizia de retragere.Sunt exceptate de la dreptul de
          retragere în ceea ce priveşte contractele la distanţă şi contractele
          în afara spaţiilor comerciale contractele de prestări de servicii,
          după prestarea completă a serviciilor, dacă executarea a început cu
          acordul prealabil expres al consumatorului şi după ce acesta a
          confirmat că a luat cunoştinţă de faptul că îşi va pierde dreptul la
          retragere după executarea completă a contractului de către
          profesionist.
        </p>
      </Section>
      <Section>
        <h2>Observații finale</h2>
        <p>
          Prin bifarea casuței din formularul de înregistrare, declar că am
          citit, înțeles și sunt de acord cu Termenii și condițiile prezentate
          în cadrul acestei pagini.
        </p>

        <p>
          Pentru orice alte întrebări sau neclaritați puteți contacta echipa
          ItoIT în secțiunea de contact.
        </p>
      </Section>
      <NavLink to={pages.app.home}>
        <Button className="bg-primary mt-6 px-6">
          <p>Către platformă</p>
        </Button>
      </NavLink>
    </div>
  )
}
